// DO NOT EDIT -- generated from fs/services/alexa/pagemetrics_service.proto

import { QueryCacheOptions, SampleOptions, SampleResults } from './search_service_types.proto';
import * as pagemetrics from '../../api/metrics/pagemetrics';
import * as protobuf from '../../../google/protobuf';
import * as search from '../../api/search';
import * as segment from '../../api/segment';

export namespace PageMetricsServicePublic {

  export const ComputePageFlowEndpoint = "/grpc/alexa.PageMetricsServicePublic/ComputePageFlow";
  /** ComputePageFlow takes a PageDefId and computes the top entry/exit pages for that page */
  export function ComputePageFlow(sender: (req: ComputePageFlowRequest, endpoint: string) => Promise<ComputePageFlowResponse>, req: ComputePageFlowRequest): { promise: () => Promise<ComputePageFlowResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ComputePageFlowEndpoint),
      endpoint: ComputePageFlowEndpoint
    };
  }

  export const ComputeJourneyMapEndpoint = "/grpc/alexa.PageMetricsServicePublic/ComputeJourneyMap";
  /** ComputeJourneyMap takes a journey configuration and computes the top journeys. */
  export function ComputeJourneyMap(sender: (req: ComputeJourneyMapRequest, endpoint: string) => Promise<ComputeJourneyMapResponse>, req: ComputeJourneyMapRequest): { promise: () => Promise<ComputeJourneyMapResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ComputeJourneyMapEndpoint),
      endpoint: ComputeJourneyMapEndpoint
    };
  }

  export const FindCommonPathsEndpoint = "/grpc/alexa.PageMetricsServicePublic/FindCommonPaths";
  export function FindCommonPaths(sender: (req: FindCommonPathsRequest, endpoint: string) => Promise<FindCommonPathsResponse>, req: FindCommonPathsRequest): { promise: () => Promise<FindCommonPathsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, FindCommonPathsEndpoint),
      endpoint: FindCommonPathsEndpoint
    };
  }
}

export interface ComputePageFlowCacheKey {
  request: ComputePageFlowRequest | null;
  searchCacheKey: search.CacheKey | null;
}

export interface ComputePageFlowRequest {
  orgId: string;
  computation: pagemetrics.PageFlowComputation | null;
  /**
   * Use to override the "now" time. Typically, you want to leave this unset for current results.
   * You should only set a value if you explicitly want to get point in time results.
   */
  now: protobuf.timestamp | null;
  /** Optional timezone, will default to "UTC" if not provided. */
  timezone: string;
  /**
   * CacheOptions is options for the query cache. Default will be
   * provided by the application if any fields are omitted.
   * Defaults are set based on the time interval of the computation.
   */
  cacheOptions: QueryCacheOptions | null;
  /**
   * If set, opts in to sampling.
   * Results will be extrapolated based on sample percent.
   */
  sampleOptions: SampleOptions | null;
}

export interface ComputePageFlowResponse {
  pageFlow: pagemetrics.PageFlow | null;
  /** ComputedAt determines when the data was computed. */
  computedAt: protobuf.timestamp | null;
  /** If non empty, a reference id for which the background computation can be managed. */
  backgroundRefId: string;
  /**
   * If set, indicates sample result details.
   * If unset or underlying percent is 100, response contains full resolution data with no options to follow up iteratively.
   */
  sampleResults: SampleResults | null;
}

export interface ComputeJourneyMapCacheKey {
  request: ComputeJourneyMapRequest | null;
  searchCacheKey: search.CacheKey | null;
}

export interface ComputeJourneyMapRequest {
  orgId: string;
  computation: pagemetrics.JourneyMapComputation | null;
  /**
   * Use to override the "now" time. Typically, you want to leave this unset for current results.
   * You should only set a value if you explicitly want to get point in time results.
   */
  now: protobuf.timestamp | null;
  /** Optional timezone, will default to "UTC" if not provided. */
  timezone: string;
  /**
   * CacheOptions is options for the query cache. Default will be
   * provided by the application if any fields are omitted.
   * Defaults are set based on the time interval of the computation.
   */
  cacheOptions: QueryCacheOptions | null;
  /**
   * If set, opts in to sampling.
   * Results will be extrapolated based on sample percent.
   */
  sampleOptions: SampleOptions | null;
}

export interface ComputeJourneyMapResponse {
  journeyMap: pagemetrics.JourneyMap | null;
  /** ComputedAt determines when the data was computed. */
  computedAt: protobuf.timestamp | null;
  /** If non empty, a reference id for which the background computation can be managed. */
  backgroundRefId: string;
  /**
   * If set, indicates sample result details.
   * If unset or underlying percent is 100, response contains full resolution data with no options to follow up iteratively.
   */
  sampleResults: SampleResults | null;
}

export interface FindCommonPathsRequest {
  journeyMap: pagemetrics.JourneyMap | null;
  constraints: segment.JourneyMapConstraints | null;
  options: pagemetrics.CommonPathOptions | null;
  eventIdent: segment.EventIdent | null;
}

export interface FindCommonPathsResponse {
  results: pagemetrics.JourneyMapPath[];
}
